import { AfterViewInit, EventEmitter, Component, Input, Output } from '@angular/core';
import { PaymentMethodModel } from '../../../shared/models/payment-method.model';
import { PaymentStepsService } from '../../services/payment-steps.service';
import { PaymentGatewayModel } from '../../../shared/models/payment-gateway.model';
import { MobileScrollToService } from '../../../shared/services/mobile-scroll-to.service';
import { FacebookService } from '../../../shared/services/facebook.service';
import { ResumeUpdaterService } from '../../../cart/services/cart-resume-updater.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
    selector: 'payment-payment-option',
    templateUrl: './payment.payment.option.component.html',
    styleUrls: ['../../payment.component.scss']
})
export class PaymentPaymentOptionComponent implements AfterViewInit {
    public total: number;
    public amountDifference = 1;
    public currentAmount;
    @Input() checked = false;
    @Input() index;
    @Input() paymentMethod: PaymentMethodModel;
    @Input() deliverable: boolean;
    @Output() activated: EventEmitter<null> = new EventEmitter();
    @Output() pending: EventEmitter<null> = new EventEmitter();
    @Output() changed: EventEmitter<PaymentMethodModel> = new EventEmitter();
    @Output() filled: EventEmitter<null> = new EventEmitter();
    @Output() unfilled: EventEmitter<null> = new EventEmitter();

    private cartItems = [];

    resumeUpdaterServiceIndexed: Subscription;

    constructor(
        protected paymentStepsService: PaymentStepsService,
        protected facebookService: FacebookService,
        protected mobileScrollToService: MobileScrollToService,
        protected resumeUpdaterService: ResumeUpdaterService,
        protected activatedRoute: ActivatedRoute
    ) {
        this.paymentStepsService.loadedPaymentGatewayConfigurations$
            .subscribe((paymentGateway: PaymentGatewayModel) => {
                this.paymentMethod.payment_gateway_tenant = paymentGateway;
            });
        this.resumeUpdaterService.validatedCoupon$.subscribe(() => {
            this.paymentStepsService.setSelectedPaymentMethod(null);
        });
        this.resumeUpdaterServiceIndexed = this.resumeUpdaterService.indexed$.subscribe((index: any) => {
            this.total = index.total;
            this.calculateAmountDifference(this.currentAmount || 1);
        });
    }

    ngAfterViewInit() {
        this.activated.emit();
        this.mobileScrollToService.scrollTo('#scroll-to-payment-options');
        this.cartItems = this.activatedRoute.snapshot.data.cartRestore || [];

        if (this.mustBeChecked()) {
            this.changedPaymentMethod();
        }
    }
    ngOnDestroy() {
        // Overrided by AutoUnsubscribe
    }

    public calculateAmountDifference(amount) {
        this.currentAmount = amount;
        this.amountDifference = this.total - this.currentAmount;
        if (this.amountDifference < 0) {
            this.amountDifference = 0;
        }
    }
    /**
     * Action on change payment method radio
     **/
    public changedPaymentMethod() {
        this.changed.emit(this.paymentMethod);
        this.unfilled.emit();

        this.facebookService.trackAddPaymentInfo(
            this.cartItems.map(item => item.categories.map(category => category.name).join(',')).join('/'),
            this.cartItems.map(item => item.id),
            this.facebookService.CONTENT_TYPE_PRODUCT,
            this.cartItems.map(item => ({'id': item.id, 'quantity': item.quantity})),
            this.cartItems.reduce((sum, item) => sum += parseInt(item.quantity, 10) * parseFloat(item.price), 0)
        );
    }
    /**
     * ready event listener. Trigger filled event.
     **/
    public onFilled() {
        this.filled.emit();
    }
    /**
     * unfilled event listener. Trigger unfilled event.
     **/
    public onUnfilled() {
        this.unfilled.emit();
    }
    /**
     * Check if option must be checked.
     **/
    public mustBeChecked() {
        return this.checked === true;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/payment/payment/option/payment.payment.option.component.ts